import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-primary-light-blue" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Seadme Nimi "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " UID "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Järgmine hooldus "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Järgmine mõõdistus "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Kabinet "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Mudel "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Seeria nr "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Röntgenitoru mudel "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Röntgenitoru seeria nr "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 tracking-wider"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "uppercase" }, " Maksimum torupinge"),
    /*#__PURE__*/_createTextVNode(" (kV) ")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 tracking-wider"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "uppercase" }, "Maksimum voolutugevus"),
    /*#__PURE__*/_createTextVNode(" (mA) ")
  ]),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Kasutus "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Tootja "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Tootja riik "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Valm. aasta "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Kiirgustegevuse staatus "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Hooldusvälp "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  }, " Mõõdistusvälp "),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "px-6 py-3 align-top text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("thead", _hoisted_1, _hoisted_3))
}